var rich_content_viewer_default = {
  "fontElementMap": "_4am2U",
  "wrapper": "tkOJV",
  "pluginContainerMobile": "KHkMX",
  "viewer": "CHIMZ",
  "android": "Y1O4r",
  "rootedTraversedContent": "dm6kF",
  "atomic": "_81IMs",
  "toolbar": "N7ez2",
  "block": "RcyaJ"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
